import {PolymerElement, html} from '@polymer/polymer/polymer-element.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';

/**
 * `cbar-progress-bar`
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarProgressBar extends PolymerElement {
  static get template() {
    return html`
      <style include="cbar-shared-styles">
        :host {
          display: block;
        }
        .empty-progress{
            background-color: lightgrey;
            height: var(--cbar-progress-height, 30px);
            border-radius: 50px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        }
        .progress-bar{
        background: var(--progress-bar-color, #ee6e73);
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-radius: 50px;
        }
      </style>
      <div class="empty-progress">
        <div class="progress-bar" id="progress-bar">
            <slot name="inner-bar-slot"></slot>
        </div>
      </div>
    `;
  }
  static get properties() {
    return {
      percentage: {
        type: Number,
        value: false,
        observer: "_setWidth"
      },
      animated: {
        type: Boolean,
        value: false,
        observer: "_checkAnimated"
      }
    }
  }
  _setWidth(percentage) {
    if (percentage > 100) {
      percentage = 100;
    }

    this.$['progress-bar'].style.width = percentage + "%";
  }

  _checkAnimated(animated) {
    if (animated === false) {
      return;
    }
  }
}

window.customElements.define('cbar-progress-bar', CbarProgressBar);
